<div class="container text-left">
  <mat-toolbar class="titulo">Outros</mat-toolbar>
  <div class="container">
    <form [formGroup]="form">
      <h3 class="subtitulo">Processo</h3>
      <div class="form-row">
        <div class="col-7">
          <app-nro-processo-input formControlName="nroProcesso" [tokenIam]="tokenIam" tipoOrdem="OUTROS"></app-nro-processo-input>
        </div>
      </div>

      <div class="form-dados-ordem">

        <app-sla-selector [form]="form"></app-sla-selector>

        <app-lista-titulares [titulares]="titulares" [tipoOrdem]='"OUTROS"' (titularesChange)="onTitularesChange($event)"></app-lista-titulares>

        <h3 class="subtitulo">Anexo</h3>
        <div class="div-add-documento">
          <div class="file-info" *ngIf="!arquivoAnexo">
            <button type="button" mat-raised-button (click)="fileInput.click()" [attr.data-cy]="'button-selecionar-arquivo'">
              <mat-icon>computer</mat-icon> Selecionar do computador
            </button>
            <input type="file" accept=".pdf" #fileInput (change)="fileBrowseHandler($event)" [attr.data-cy]="'input-arquivo'"/>
          </div>
          <div class="file-info" *ngIf="arquivoAnexo">
            <p [attr.data-cy]="'nome-arquivo'"><strong>Arquivo anexado:</strong> {{ arquivoAnexo.name }}</p>
            <button type="button" class="remover-anexo" mat-raised-button (click)="removeFile()" [attr.data-cy]="'button-remover-anexo'">
              Remover
            </button>
          </div>
        </div>

        <h3 class="subtitulo mt-4">Descrição da Ordem</h3>
        <div class="form-row ordem-textarea">
          <div class="col-12">
            <mat-form-field appearance="outline" class="inputs">
              <textarea
                matInput
                [placeholder]="MENSAGEM_DESCRICAO"
                formControlName="descricaoOrdem"
                maxlength="400"
                minlength="60"
                rows="6"
              >
              </textarea>
              <mat-hint align="end">{{ descricaoOrdem.value?.length }} / 400</mat-hint>
              <mat-error *ngIf="descricaoOrdem.touched && descricaoOrdem.hasError('required')">
                Descrição da ordem é <strong>obrigatória</strong>
              </mat-error>
              <mat-error *ngIf="descricaoOrdem.hasError('minlength')">
                Descrição da ordem deve conter <strong>no mínimo 60 caracteres</strong>. {{ descricaoOrdem.value?.length }} / 400
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row ">
          <div class="col-sm-7"></div>
          <div class="col-sm-5">
            <app-acao-buttons
              [tipoOrdem]="'OUTROS'"
              (onConfirmar)="enviarOrdem()"
            ></app-acao-buttons>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
